import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Icon from '@c/icon'
import { Paginator, makePageUrl } from '@/hooks/resource/use-paginator'
import './index.css'

/**
 *
 * @param {{paginator: Paginator,baseSlug: String}} props
 */
function Pagination(props) {
  const r = props?.paginator?.result
  if (r.totalPages <= 1) {
    return null
  }
  return (
    <nav className="zeo-pagination">
      <PaginationButton baseSlug={props.baseSlug} page={r.previousPage?.page}>
        <Icon name="chevron-left" />
      </PaginationButton>
      {!!r.previousPage?.pages?.length &&
        r.previousPage.pages.map(pageNumber => {
          return (
            <PaginationButton
              key={pageNumber}
              baseSlug={props.baseSlug}
              page={pageNumber}
            >
              {pageNumber}
            </PaginationButton>
          )
        })}
      <PaginationButton
        baseSlug={props.baseSlug}
        page={r.currentPage}
        active={true}
      >
        {r.currentPage}
      </PaginationButton>
      {!!r.nextPage?.pages?.length &&
        r.nextPage.pages.map(pageNumber => {
          return (
            <PaginationButton
              key={pageNumber}
              baseSlug={props.baseSlug}
              page={pageNumber}
            >
              {pageNumber}
            </PaginationButton>
          )
        })}
      <PaginationButton baseSlug={props.baseSlug} page={r.nextPage?.page}>
        <Icon name="chevron-right" />
      </PaginationButton>
    </nav>
  )
}
Pagination.propTypes = {
  paginator: PropTypes.instanceOf(Paginator),
  baseSlug: PropTypes.string
}

export default Pagination

// Sub components

/**
 *
 * @param {{url: String|null,className: String|null}} props
 */
function PaginationButtonContainer(props) {
  return props.url ? (
    <Link to={props.url} className={props.className}>
      {props.children}
    </Link>
  ) : (
    <div className={props.className}>{props.children}</div>
  )
}
PaginationButtonContainer.propTypes = {
  url: PropTypes.string
}
/**
 *
 * @param {{baseSlug: String,page: String|null,active: boolean }} props
 */
function PaginationButton(props) {
  const url = makePageUrl(props.baseSlug, props.page)
  return (
    <PaginationButtonContainer
      className={cn(
        'pagination-button',
        !url && 'disabled',
        props.active && 'active'
      )}
      url={url}
    >
      {props.children}
    </PaginationButtonContainer>
  )
}

PaginationButton.propTypes = {
  baseSlug: PropTypes.string,
  page: PropTypes.string,
  active: PropTypes.bool
}
